import axios from "axios";

const IS_DEV = import.meta.env.DEV;
const IS_HML = window.location.hostname.startsWith("hml-");
const IS_SANDBOX = window.location.hostname.startsWith("sandbox-");

export const BFF_BASE_URL = IS_DEV
  ? "/bff-proxy/service/core"
  : IS_HML
    ? "https://hml-bff.barte.com/service/core"
    : IS_SANDBOX
      ? "https://sandbox-bff.barte.com/service/core"
      : "https://bff.barte.com/service/core";

export const N8N_BASE_URL =
  "https://prdc-n8n-webhook.barte.com/webhook/prd/v1/sellers/rates";
export const N8N_BARTE_TAXES_URL =
  "https://prdc-n8n-webhook.barte.com/webhook/prd/commission/barte-taxes";

export const bffApi = axios.create();

bffApi.interceptors.request.use((config) => {
  const bearerToken = localStorage.getItem("userBearerToken");
  config.headers["Authorization"] = `Bearer ${bearerToken}`;
  return config;
});

export const sellerRatesApi = axios.create();

sellerRatesApi.interceptors.request.use((config) => {
  const apiToken = localStorage.getItem("userApiToken");
  const bearerToken = localStorage.getItem("userBearerToken");
  config.headers["X-Token-Api"] = apiToken;
  config.headers["Authorization"] = `Bearer ${bearerToken}`;
  return config;
});
